// @flow

import React from "react";

import { MessageCard as StyledMessageCard } from "./styles";

type Props = {
  children: React$Node,
  first: boolean,
  width?: string,
  isChecklistNotification?: boolean,
  isMessage?: boolean,
};

const MessageCard = ({
  children,
  first,
  width,
  isChecklistNotification = false,
  isMessage = false,
  ...restProps
}: Props) => (
  <StyledMessageCard
    first={first}
    width={width}
    isChecklistNotification={isChecklistNotification}
    isMessage={isMessage}
    {...restProps}
  >
    {children}
  </StyledMessageCard>
);

export default MessageCard;
